import React from 'react';
import classnames from 'classnames';
import { map, noop } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';

// resolution icon names based on option name
const RESOLUTION_ICONS = {
    resolved: 'thumbUp',
    unresolved: 'thumbDown',
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { resolutionInput as ResolutionInput } from 'ui/views/generic/resolutionInput';
 *
 * // render
 * <ResolutionInput propName='propValue'/>
 */
export const resolutionInput = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-resolution-input', {
        'ui-resolution-input--disabled': props.disabled,
    } );

    return (
        <div className={ widgetClassName }>

            {/* title */}
            <div className='ui-resolution-input__title'>
                { getLabel( 'displayTextResolution' ) } -
            </div>

            {/* options */}
            <div className='ui-resolution-input__options'>
                {
                    map( props.options, option => {

                        // item class name
                        const itemClassName = classnames( 'ui-resolution-input__options__item', {
                            'ui-resolution-input__options__item--active': props.value === option.value,
                        } );

                        return (
                            <div key={ option.name } className={ itemClassName } onClick={ () => props.onChange( option.value ) }>
                                <div className='ui-resolution-input__options__item__icon'>
                                    <Icon name={ RESOLUTION_ICONS[ option.name ] } />
                                </div>
                                <div className='ui-resolution-input__options__item__title'>
                                    { getLabel( option.title ) }
                                </div>
                            </div>
                        );
                    } )
                }
            </div>
        </div>
    );
};

// set display name
resolutionInput.displayName = 'resolutionInput';

// set default props
resolutionInput.defaultProps = {
    disabled: false,
    options: [],
    value: null,
    onChange: noop,
};

// prop types
resolutionInput.propTypes = {};
